import Layout from "./Layout"
import useRegionalStore from "../store/useRegionalStore"
const Home = () =>{
   const { province, regency, district } = useRegionalStore();
    return(
        <Layout>
        <div className="mb-20">
             <div className="text-center text-xs text-blue-600/75 font-medium">
                  PROVINSI
            </div>
            <div className="text-center text-4xl">
                  {province}
            </div>
         </div>
          <div className="mb-20">
             <div className="text-center text-xs text-blue-600/75 font-medium">
                  KOTA/KABUPATEN
            </div>
            <div className="text-center text-4xl">
                  {regency}
            </div>
         </div>
         <div className="mb-20">
             <div className="text-center text-xs text-blue-600/75 font-medium">
                  KECAMATAN
            </div>
            <div className="text-center text-4xl">
                  {district}
            </div>
         </div>
        </Layout>
    )
}

export default Home